import React from 'react';
import CustomButton from '../../../common/components/CustomButton';

export default function RecipientCopyrightTransferFormAmendmentView1({
  karaokeOrder,
  onNext,
} : {
  karaokeOrder: {
    title: string,
    applicant_name: string,
  },
  onNext: () => void,
}) {
  return (
    <>
      <h2>
        「{karaokeOrder.title}」
        <br />
        契約更新のお願い
      </h2>
      <div className="figure">
        <div className="figure__inner">
          <img src="/img/karaoke_service/copyright_pt2.png" alt="著作権の手続き" />
        </div>
      </div>
      <p className="mb50">
        ■変更点
        <br />
        これまでは著作権を12種類に分けた「支分権」のうち、「通信カラオケ」と「放送権」だけをFrekulが預かり、その使用料の徴収業務をNexTone社に委託していました。
        <br />
        今回の契約更新では、すべての支分権をFrekulが預からせていただくことになります。
        <br />
        <br />
        これにより、誰か別の人があなたの曲を使いたいと思った時の問合せ窓口がFrekulになります。
        <br />
        窓口を統一することで、あなたの曲がより使われやすい状態を作ります。
        <br />
        「あなたの曲を使いたい」という問合せが入った場合、相手とのやり取りをFrekulに任せることもできるし、使用の可否や使用料について希望を伝えることもできます。
        <br />
        <br />
        NexToneに委託する範囲については、当面は今まで通り「通信カラオケ」と「放送権」だけとなります。
        <br />
        今後、希望する曲は「インタラクティブ配信権」なども管理委託し、収益化できるような形を目指します。
        <br />
        <br />
        今回の契約更新で、著作権をFrekulがお預かりすることになりますが、あなた自身がライブで演奏したり、サブスク配信したりすることは、これまで通り自由に行っていただくことができます。
        <br />
        <br />
        契約更新に同意いただける場合、「次へ」を押してください。
      </p>
      <br />
      <div className="loader_parts_container">
        <form className="cake_ajax_form">
          <div className="form__body">
            <dl>
              <dd>
                <ul className="col" style={{ float: 'none' }}>
                  <li className="col span_24">
                    <span className="col span_6">曲名:</span>
                    <span className="col span_18">{karaokeOrder.title}</span>
                  </li>
                  <li className="col span_24">
                    <span className="col span_6">お申込者さま名（あなたのお名前）:</span>
                    <span className="col span_18">{karaokeOrder.applicant_name}</span>
                  </li>
                </ul>
              </dd>
            </dl>
            <ul>
              <li className="bt">
                <CustomButton type="default" onClick={() => onNext()}>次へ</CustomButton>
              </li>
            </ul>
          </div>
        </form>
      </div>
      <p>
        同意できない場合や、著作権契約を解約したい場合などは
        <a href="https://frekul.com/contact">こちら</a>
        からご連絡ください。
      </p>
    </>
  );
}
